module.exports = __webpack_public_path__ + "assets/img/4-xs.22bcc9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/why/4-xs.jpg
// module id = G/Uq
// module chunks = 1